import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import BookingModal from './BookingModal';
import AuthModals from './AuthModals';
import '../styles/LegalResources.css';

const LegalResources: React.FC = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showBooking, setShowBooking] = useState(false);

  return (
    <div className="resources-page">
      <Header 
        onOpenLogin={() => setShowLogin(true)}
        onOpenSignup={() => setShowSignup(true)}
      />
      
      <section className="resources-banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1 className="banner-title">Legal Resources</h1>
          <p className="banner-subtitle">
            Comprehensive legal guides, articles, and resources to help you understand your rights and legal processes.
          </p>
          <div className="banner-icons">
            <div className="banner-icon">
              <i className="fas fa-book"></i>
              <span>Guides</span>
            </div>
            <div className="banner-icon">
              <i className="fas fa-file-alt"></i>
              <span>Articles</span>
            </div>
            <div className="banner-icon">
              <i className="fas fa-graduation-cap"></i>
              <span>Learn</span>
            </div>
          </div>
        </div>
      </section>

      <div className="resources-container">
        <div className="resources-content">
          <section className="featured-articles">
            <h2>Featured Legal Articles</h2>
            <div className="articles-grid">
              <article className="article-card">
                <div className="article-category">Civil Law</div>
                <h3>Understanding Property Rights in India</h3>
                <p>A comprehensive guide to property ownership, transfer procedures, and legal protections for property owners.</p>
                <div className="article-meta">
                  <span className="read-time">5 min read</span>
                  <span className="publish-date">Dec 15, 2024</span>
                </div>
              </article>
              
              <article className="article-card">
                <div className="article-category">Criminal Law</div>
                <h3>Your Rights During Police Investigation</h3>
                <p>Know your fundamental rights when dealing with police investigations and criminal proceedings in India.</p>
                <div className="article-meta">
                  <span className="read-time">7 min read</span>
                  <span className="publish-date">Dec 10, 2024</span>
                </div>
              </article>
              
              <article className="article-card">
                <div className="article-category">Matrimonial</div>
                <h3>Divorce Procedures in India: A Complete Guide</h3>
                <p>Step-by-step guide to divorce procedures, required documents, and legal considerations for matrimonial cases.</p>
                <div className="article-meta">
                  <span className="read-time">10 min read</span>
                  <span className="publish-date">Dec 5, 2024</span>
                </div>
              </article>
            </div>
          </section>

          <section className="legal-guides">
            <h2>Legal Process Guides</h2>
            <div className="guides-grid">
              <div className="guide-item">
                <i className="fas fa-file-signature"></i>
                <h3>Contract Drafting Guide</h3>
                <p>Learn the essential elements of contract drafting and key clauses to protect your interests.</p>
                <a href="#" className="guide-link">Read Guide</a>
              </div>
              
              <div className="guide-item">
                <i className="fas fa-home"></i>
                <h3>Property Purchase Process</h3>
                <p>Complete checklist for property buying, document verification, and legal due diligence.</p>
                <a href="#" className="guide-link">Read Guide</a>
              </div>
              
              <div className="guide-item">
                <i className="fas fa-briefcase"></i>
                <h3>Starting a Business in India</h3>
                <p>Legal requirements, registration procedures, and compliance for new business ventures.</p>
                <a href="#" className="guide-link">Read Guide</a>
              </div>
              
              <div className="guide-item">
                <i className="fas fa-shield-alt"></i>
                <h3>Consumer Rights Protection</h3>
                <p>Understanding consumer protection laws, complaint procedures, and remedies available.</p>
                <a href="#" className="guide-link">Read Guide</a>
              </div>
            </div>
          </section>

          <section className="legal-tools">
            <h2>Legal Tools & Resources</h2>
            <div className="tools-grid">
              <div className="tool-item">
                <i className="fas fa-calculator"></i>
                <h3>Legal Fee Calculator</h3>
                <p>Estimate legal costs for various services and court procedures.</p>
                <button className="tool-btn">Use Calculator</button>
              </div>
              
              <div className="tool-item">
                <i className="fas fa-download"></i>
                <h3>Document Templates</h3>
                <p>Download legal document templates for common legal needs.</p>
                <button className="tool-btn">Browse Templates</button>
              </div>
              
              <div className="tool-item">
                <i className="fas fa-search"></i>
                <h3>Lawyer Directory</h3>
                <p>Find qualified lawyers by practice area and location.</p>
                <button className="tool-btn">Search Lawyers</button>
              </div>
              
              <div className="tool-item">
                <i className="fas fa-question-circle"></i>
                <h3>Legal FAQ</h3>
                <p>Get answers to frequently asked legal questions.</p>
                <button className="tool-btn">View FAQ</button>
              </div>
            </div>
          </section>

          <section className="newsletter-section">
            <div className="newsletter-card">
              <h2>Stay Updated with Legal News</h2>
              <p>Subscribe to our newsletter for latest legal updates, case studies, and legal tips.</p>
              <div className="newsletter-form">
                <input type="email" placeholder="Enter your email address" className="newsletter-input" />
                <button className="newsletter-btn">Subscribe</button>
              </div>
            </div>
          </section>
        </div>
      </div>

      <Footer />
      
      <BookingModal 
        isOpen={showBooking}
        onClose={() => setShowBooking(false)}
      />
      <AuthModals 
        showLogin={showLogin}
        showSignup={showSignup}
        onCloseLogin={() => setShowLogin(false)}
        onCloseSignup={() => setShowSignup(false)}
        onOpenSignup={() => setShowSignup(true)}
        onOpenLogin={() => setShowLogin(true)}
      />
    </div>
  );
};

export default LegalResources;